import {bootAnalytics} from './analytics/consent/analytics';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';

import {App} from './App';
import {ShellRouteError} from './ShellErrorBoundary';
import './fonts.css';
import '@wandb/components/assets/index.css';
import './styles.css';

/*
  Before render, so Segment's stub is installed before anything can call
  `analytics.track`. An import edge rather than a second `<script>` in
  index.html: `@module-federation/vite` collapses every module entry in the HTML
  into one bootstrap chunk, so document order guarantees nothing there.
*/
bootAnalytics();

const router = createBrowserRouter([
  {path: '*', element: <App />, errorElement: <ShellRouteError />},
]);

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
